import React from 'react';

import { Header } from 'modules/checkout/presentation/components/molecules';
import { StatusInformation } from 'modules/checkout/presentation/components/organisms';
import { AllRightsFooter } from 'shared/presentation/components/atoms';
import { ANIMATIONS, ICONS } from 'shared/presentation/constants';
import { useLocale, useNavigation } from 'shared/presentation/contexts';

import * as S from './styles';

const CheckoutSuccess: React.FC = () => {
  const { t } = useLocale('checkout');
  const navigation = useNavigation();

  return (
    <S.Container>
      <Header />

      <StatusInformation
        animation={{
          data: ANIMATIONS.SUCCESS,
          width: 250,
          height: 250,
        }}
        title={t('All right!')}
        message={t('The payment was processed and the contract was generated!')}
        actions={[
          {
            text: t('Home'),
            onClick: () => navigation.replace('/'),
            icon: ICONS.HOME,
          },
        ]}
      />

      <AllRightsFooter />
    </S.Container>
  );
};

export default CheckoutSuccess;
